import {
  Box,
  Button,
  Divider,
  Grid,
  makeStyles,
  Paper,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import EditOutlined from '@material-ui/icons/EditOutlined';
import KenPopover from '../../../../Components/KenPopOver';
import KenSelectWrap from '../../../../global_components/KenSelect';
import EventSeatIcon from '@material-ui/icons/EventSeat';
import { FiEdit } from 'react-icons/fi';
import ProfileImg from '../../../../Assets/Card/studentDummy.png';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: 'black',
    backgroundColor: '#F5F6FA',
    width: '150px',
    height: '70px',
  },
  mg: {
    marginTop: '10px',
  },
  studInfo: {
    fontFamily: "'Open Sans'",
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '100%',
    color: '#02195E',
  },
  containerModify: {
    flex: 1,
    overflowY: 'scroll',
    padding: '16px',
    overflowX: 'hidden',
    border: '1px solid #C4C4C4',
    borderRadius: '5px',
    minHeight: '55vh',
    maxHeight: '65vh',
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      opacity: '0.2',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#C4C4C4',
      borderRadius: '30px',
      opacity: '0.1',
      outline: `1px solid transparent`,
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: `#02195E`,
    },
  },
  small: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  basicInfo: {
    fontFamily: "'Open Sans'",
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '100%',
    textAlign: 'center',
    color: '#061938',
    padding: '16px',
  },
}));

function SeatingArrangement({
  studentsData,
  SEATING_COLUMNS,
  roomChoosen,
  numStudents,
  selectValueSpace,
  layoutSize,
  setLayoutSize,
  roomDropdown,
  setSwapSeats,
  examId,
  handleDialog,
  setMessage,
  setValue,
  // handleSelectChangeCourse,
}) {
  const [selectValueCourse, setSelectValueCourse] = React.useState(
    roomDropdown[0].value
  );
  const classes = useStyles();
  const roomOptions = [];
  roomChoosen.map((item) => {
    roomOptions.push({
      label: item?.room,
      value: item?.room,
      capacity: item?.capacity,
    });
  });
  const [selectedRoom, setSelectedRoom] = useState(roomOptions[0]);
  const [anchorEl, setAnchorEl] = React.useState();
  const [anchorElStudent, setAnchorElStudent] = React.useState();
  const [sName, setSName] = React.useState('');
  const [sId, setSId] = React.useState('');
  const [selectValueExam, setSelectValueExam] = React.useState();
  const [currentSeat, setCurrentSeat] = useState();
  const [alterSeat, setAlterSeat] = useState();
  const [seatAllocation, setSeatAllocation] = useState([]);
  const [studentArrays, setStudentArrays] = React.useState(studentsData);
  const [studentArraySort, setStudentArraySort] = React.useState();
  const [selectOptionsExam, setSelectOptionsExam] = React.useState([]);

  const handleRoomChange = (event) => {
    let val = event.target.value;
    let data = roomOptions.filter((el) => el.value === val);
    setSelectedRoom(data[0]);
  };

  const handleSelectChangeExam = (e, value) => {
    setSelectValueExam(e.target.value);
    const swap = studentArraySort.filter(
      (item) => item.seatNumber === e.target.value
    );
    setAlterSeat(swap[0]);
  };

  //filter data according to room
  useEffect(() => {
    if (selectedRoom) {
      let studData = studentsData.filter(
        (el) => el.roomNo === selectedRoom.value
      );
      setStudentArrays(studData);
    }
  }, [selectedRoom]);
  //seat sort
  useEffect(() => {
    setStudentArraySort(
      studentArrays.sort((a, b) => a?.seatNumber - b?.seatNumber)
    );
  }, [studentArrays]);

  //seat swap option
  useEffect(() => {
    if (studentArraySort) {
      let studData = studentArraySort.filter((el) => {
        return el.roomNo === selectedRoom.value;
      });

      let studentsOption = [];
      studData?.map((item, index) => {
        return studentsOption.push({
          label: item?.rollNumber !== null ? item?.rollNumber : 'NULL',
          value: item?.seatNumber === null ? 'NULL' : item?.seatNumber,
        });
      });

      setSelectOptionsExam(studentsOption);
    }
  }, [studentArraySort]);
  //seat swap function
  const handleStudent = (id) => {
    const studentArrayCopy = [...studentArraySort];
    const currentSeatCopy = currentSeat;
    const alterSeatCopy = alterSeat;
    let a = currentSeatCopy.seatNumber;
    let b = alterSeatCopy.seatNumber;
    [a, b] = [b, a];
    if (currentSeatCopy.rollNumber != alterSeatCopy.rollNumber) {
      const alterData = { ...alterSeatCopy, seatNumber: b };
      const currentData = { ...currentSeatCopy, seatNumber: a };

      const alterDataIndex = studentArraySort.findIndex(
        (data) => data?.seatNumber === b
      );
      console.log('alterDataIndex', alterDataIndex);
      const currentDataIndex = studentArraySort.findIndex(
        (data) => data?.seatNumber === a
      );
      console.log('currentDataIndex', currentDataIndex);
      studentArrayCopy[alterDataIndex] = alterData;
      studentArrayCopy[currentDataIndex] = currentData;

      // studentArrayCopy.push(alterData);
      // studentArrayCopy.push(currentData);
    } else {
      setMessage('same roll number selected', currentSeatCopy?.rollNumber);
      handleDialog();
    }
    if (studentArrayCopy.length > 0) {
      setStudentArrays(studentArrayCopy);
      const swapData = [];
      for (var i = 0; i < studentArrayCopy.length; i++) {
        swapData.push({ ...studentArrayCopy[i], examId: examId });
      }
      if (swapData.length > 0) {
        setSwapSeats(swapData);
      }
    }

    dismissPopoverStudent();
  };
  const dismissPopover = () => {
    setAnchorEl(null);
  };
  const dismissPopoverStudent = () => {
    setAnchorElStudent(null);
  };
  const handlePopoverOpenStudent = (event, studentArrayId) => {
    // setSName(studentArrayName);
    setSId(studentArrayId);
    setAnchorElStudent(event.currentTarget);
  };
  //seating arrangement
  useEffect(() => {
    const modifyStudData = [];
    let indexResp = 0;
    for (let i = 0; i < selectedRoom?.capacity; i++) {
      if (studentArraySort) {
        if (i == 0) {
          modifyStudData.push(studentArraySort[i]);
          indexResp++;
        } else if (i % (selectValueSpace + 1) === 0) {
          if (studentArraySort[indexResp]) {
            modifyStudData.push(studentArraySort[indexResp]);
          } else {
            modifyStudData.push({
              seatNumber: null,
              roomNo: null,
              rollNumber: null,
            });
          }

          indexResp++;
        } else {
          modifyStudData.push({
            seatNumber: null,
            roomNo: null,
            rollNumber: null,
          });
        }
      }
    }
    setSeatAllocation(modifyStudData);
  }, [studentArraySort]);
  console.log('seatAllocation', seatAllocation);

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        className={classes.basicInfo}
      >
        <Grid item md={3} sm={12} xs={12}></Grid>
        <Grid item md={3} sm={12} xs={12}></Grid>
        <Grid item md={2} sm={4} xs={12}>
          <Typography> No. of student :{studentsData.length}</Typography>
        </Grid>
        <Grid item md={2} sm={4} xs={5}>
          <Typography>Room Number</Typography>
        </Grid>
        <Grid item md={2} sm={4} xs={7}>
          <KenSelectWrap
            options={roomOptions}
            value={selectedRoom.value}
            dropdownColor="#FFFFFF"
            onChange={(event) => {
              handleRoomChange(event);
            }}
            required
          />
        </Grid>
      </Grid>
      <Box className={classes.containerModify}>
        <Grid container spacing={2}>
          {seatAllocation &&
            seatAllocation.map((item) => {
              return (
                <Grid item md={2}>
                  <Paper
                    align="center"
                    elevation={0}
                    className={classes.studInfo}
                    style={{
                      backgroundColor: '#F5F6FA',
                    }}
                  >
                    {item?.seatNumber !== null ? (
                      <Box>
                        <Typography
                          align="center"
                          style={{ margin: '4px', padding: '4px' }}
                        >
                          <span
                            style={{ display: 'flex', alignItems: 'center' }}
                          >
                            <Avatar
                              component={'span'}
                              alt={item?.rollNumber}
                              src={ProfileImg}
                              className={classes.small}
                            />
                            {/* <img src={ProfileImg}/> */}
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            {item?.rollNumber} {/* </Avatar> */}
                          </span>
                        </Typography>
                        <Typography
                          align="center"
                          style={{
                            cursor: 'pointer',
                            margin: '4px',
                            padding: '4px',
                          }}
                          onClick={(e) => {
                            setCurrentSeat(item);
                            handlePopoverOpenStudent(
                              e,
                              item?.seatNumber ? item?.seatNumber : ''
                            );
                          }}
                        >
                          <span
                            style={{ display: 'flex', alignItems: 'center' }}
                          >
                            &nbsp;&nbsp;
                            <FiEdit />
                            &nbsp;&nbsp;&nbsp;&nbsp; Change Seat
                          </span>
                        </Typography>
                      </Box>
                    ) : (
                      <Box style={{ padding: '40px' }}>
                        <Typography>{''}</Typography>
                      </Box>
                    )}
                  </Paper>
                </Grid>
              );
            })}
        </Grid>
      </Box>

      <KenPopover
        open={anchorElStudent}
        anchorEl={anchorElStudent}
        handleClose={dismissPopoverStudent}
      >
        <Box p={2} className={classes.popoverContent}>
          <Grid container>
            <Grid item xs={12} sm={12}>
              <KenSelectWrap
                label="Select Type of Exam"
                options={selectOptionsExam}
                value={selectValueExam}
                dropdownColor="#FFFFFF"
                onChange={(e, value) => handleSelectChangeExam(e, value)}
                required
              />
            </Grid>
            <Button
              className={classes.mg}
              variant="contained"
              onClick={() => handleStudent(sId)}
            >
              save
            </Button>
          </Grid>
        </Box>
      </KenPopover>
      <KenPopover
        open={anchorEl}
        anchorEl={anchorEl}
        handleClose={dismissPopover}
      >
        <Box p={2} className={classes.popoverContent}>
          <p>{sName}</p>
        </Box>
      </KenPopover>
    </>
  );
}
export default SeatingArrangement;
